/**
 * i18n.js
 *
 * This will setup the i18n language files and locale data for your app.
 *
 *   IMPORTANT: This file is used by the internal build
 *   script `extract-intl`, and must use CommonJS module syntax
 *   You CANNOT use import/export in this file.
 */
// const addLocaleData = require('react-intl').addLocaleData; //eslint-disable-line
// const enLocaleData = require('react-intl/locale-data/en');

/**
 * No idea if this type is correct, but it shuts up the compiler
 * Feature not currently used, so it can be dealt with later
 * I just needed to convert this file to an ES Module, despite the above warning
 * - Brian Pennington 07/06/23
 */
type Message = Record<string, Record<string, any>>;

let enTranslationMessages: Message = {};

/**
 * This converts a CommonJS module into ESM
 */
// eslint-disable-next-line func-names
(async function () {
  enTranslationMessages = (await import('./translations/en.json')).default;
})();

// addLocaleData(enLocaleData);

export const DEFAULT_LOCALE = 'en';

// prettier-ignore
export const appLocales = [
  'en',
];

export const formatTranslationMessages = (
  locale: string,
  messages: Message
) => {
  const defaultFormattedMessages =
    locale !== DEFAULT_LOCALE
      ? formatTranslationMessages(DEFAULT_LOCALE, enTranslationMessages)
      : {};
  const flattenFormattedMessages = (
    formattedMessages: Message,
    key: string
  ) => {
    const formattedMessage: Message =
      !messages[key] && locale !== DEFAULT_LOCALE
        ? defaultFormattedMessages[key]
        : messages[key];
    return Object.assign(formattedMessages, {
      [key]: formattedMessage,
    }) as Message;
  };
  return Object.keys(messages).reduce(flattenFormattedMessages, {} as Message);
};

export const translationMessages = {
  en: formatTranslationMessages('en', enTranslationMessages),
};
